import { render } from "./AccountsList.vue?vue&type=template&id=8bc85fde&scoped=true"
import script from "./AccountsList.vue?vue&type=script&lang=js"
export * from "./AccountsList.vue?vue&type=script&lang=js"

import "./AccountsList.vue?vue&type=style&index=0&id=8bc85fde&scoped=true&lang=less"

import exportComponent from "D:\\过去云盘内容\\前端代码\\前端项目\\rdsv3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8bc85fde"]])

export default __exports__